const REF_STORAGE_KEY = 'referpulse_attribution';
const REFERPULSE_BASE_URL = import.meta.env.VITE_REFERPULSE_BASE_URL || 'https://webhooks.hapday.live/referpulse';

const RESERVED_PATHS = new Set([
  '',
  'age',
  'email',
  'gender',
  'menu',
  'paywall',
  'quiz',
  'registration',
]);

const normalizeRef = (value) => {
  if (!value || typeof value !== 'string') return null;
  return value.trim().slice(0, 100) || null;
};

export function saveReferpulseAttributionOnce() {
  const params = new URLSearchParams(window.location.search);
  const refFromQuery = normalizeRef(params.get('ref'));
  const firstPathSegment = window.location.pathname.split('/').filter(Boolean)[0] || '';
  const slug = firstPathSegment.toLowerCase();

  if (refFromQuery) {
    saveAttribution({
      ref: refFromQuery,
      slug: '',
      domain: window.location.hostname,
      landing_url: `${window.location.origin}${window.location.pathname}${window.location.search}`,
      params,
    });
    return;
  }

  if (!slug || RESERVED_PATHS.has(slug)) return;

  fetch(`${REFERPULSE_BASE_URL}/resolve.php?slug=${encodeURIComponent(slug)}`)
    .then((response) => (response.ok ? response.json() : null))
    .then((data) => {
      const ref = normalizeRef(data?.ref);
      if (!ref) return;

      saveAttribution({
        ref,
        slug,
        domain: window.location.hostname,
        landing_url: `${window.location.origin}${window.location.pathname}${window.location.search}`,
        params,
      });
    })
    .catch(() => {});
}

function saveAttribution({ ref, slug, domain, landing_url, params }) {
  const attribution = {
    ref,
    slug,
    domain,
    landing_url,
    utm_source: params.get('utm_source') || '',
    utm_medium: params.get('utm_medium') || '',
    utm_campaign: params.get('utm_campaign') || '',
  };

  localStorage.setItem(REF_STORAGE_KEY, JSON.stringify(attribution));
}

export function getReferpulseAttribution() {
  const raw = localStorage.getItem(REF_STORAGE_KEY);
  if (!raw) return null;

  try {
    const data = JSON.parse(raw);
    return data?.ref ? data : null;
  } catch {
    return null;
  }
}

export function getReferpulseBaseUrl() {
  return REFERPULSE_BASE_URL;
}
